import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { VisualChartType } from 'src/app/shared/chart/chart';

@Component({
  selector: 'visual-placeholder',
  templateUrl: './VisualPlaceholder.component.html',
  styleUrls: ['./VisualPlaceholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VisualPlaceholderComponent {
  public visualType = input.required<VisualChartType>();
  public showDragToolTip = input(true);
}

